"use strict";
/**
 * SSA Table Constants
 *
 * DynamoDB table names for SSA work products.
 * These are dedicated tables separate from the main DOCUMENTS table.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSA_EDGE_LABELS = exports.SSA_VERTEX_LABELS = exports.SSA_CACHE_KEYS = exports.SSA_GSI = exports.SSA_TABLES = void 0;
exports.getSSATableName = getSSATableName;
/**
 * SSA-specific table names
 */
exports.SSA_TABLES = {
    /** Safety assessment process entities */
    SAFETY_ASSESSMENTS: 'SAFETY_ASSESSMENTS',
    /** SFHA work products */
    SFHA_WORK_PRODUCTS: 'SFHA_WORK_PRODUCTS',
    /** FTA work products */
    FTA_WORK_PRODUCTS: 'FTA_WORK_PRODUCTS',
    /** FMEA work products */
    FMEA_WORK_PRODUCTS: 'FMEA_WORK_PRODUCTS',
    /** CMA work products */
    CMA_WORK_PRODUCTS: 'CMA_WORK_PRODUCTS',
    /** SSA jobs for Step Functions tracking */
    SSA_JOBS: 'SSA_JOBS',
};
/**
 * Get table name with environment suffix
 */
function getSSATableName(tableName, envSuffix) {
    const suffix = envSuffix || process.env.ENV_SUFFIX || 'dev';
    return `${exports.SSA_TABLES[tableName]}_${suffix}`;
}
/**
 * GSI names for SSA tables
 */
exports.SSA_GSI = {
    /** GSI for querying assessments by project */
    ASSESSMENT_BY_PROJECT: 'projectId-index',
    /** GSI for querying work products by assessment */
    WORK_PRODUCT_BY_ASSESSMENT: 'assessmentId-index',
    /** GSI for querying jobs by assessment */
    JOB_BY_ASSESSMENT: 'assessmentId-index',
    /** GSI for querying jobs by user */
    JOB_BY_USER: 'userId-index',
};
/**
 * SSA Redis cache keys
 */
exports.SSA_CACHE_KEYS = {
    /** SSA session state */
    SESSION: (assessmentId, userId) => `ssa:session:${assessmentId}:${userId}`,
    /** SSA job state */
    JOB: (jobId) => `ssa:job:${jobId}`,
    /** Traceability summary cache */
    TRACEABILITY: (assessmentId) => `ssa:traceability:${assessmentId}`,
    /** Work product lock */
    LOCK: (workProductId) => `ssa:lock:${workProductId}`,
};
/**
 * Neptune vertex labels for SSA graph
 */
exports.SSA_VERTEX_LABELS = {
    SSA_WORKFLOW: 'SSAWorkflow',
    SYSTEM_FUNCTION: 'SystemFunction',
    FAILURE_CONDITION: 'FailureCondition',
    FTA_EVENT: 'FTAEvent',
    FTA_GATE: 'FTAGate',
    FMEA_ITEM: 'FMEAItem',
    CMA_ANALYSIS: 'CMAAnalysis',
    RELIABILITY_RECORD: 'ReliabilityRecord',
    DERIVED_REQUIREMENT: 'DerivedRequirement',
};
/**
 * Neptune edge labels for SSA graph
 */
exports.SSA_EDGE_LABELS = {
    HAS_FUNCTION: 'HAS_FUNCTION',
    HAS_FAILURE_CONDITION: 'HAS_FAILURE_CONDITION',
    CAUSES: 'CAUSES',
    INPUT_TO: 'INPUT_TO',
    USES_FAILURE_RATE: 'USES_FAILURE_RATE',
    TRACES_TO: 'TRACES_TO',
    MITIGATES: 'MITIGATES',
    DERIVES: 'DERIVES',
    PART_OF: 'PART_OF',
};
//# sourceMappingURL=ssa-tables.js.map